import { useEffect } from "react";
import { SiteAbout } from "@/components/myfirstmarathon/site/SiteAbout";
import { SiteCoach } from "@/components/myfirstmarathon/site/SiteCoach";
import { SiteFinalCTA } from "@/components/myfirstmarathon/site/SiteFinalCTA";
import { SiteFooter } from "@/components/myfirstmarathon/site/SiteFooter";
import { SiteHero } from "@/components/myfirstmarathon/site/SiteHero";
import { SiteKeepsakeQuote } from "@/components/myfirstmarathon/site/SiteKeepsakeQuote";
import { SiteNav } from "@/components/myfirstmarathon/site/SiteNav";
import { SitePlan } from "@/components/myfirstmarathon/site/SitePlan";
import { SitePricing } from "@/components/myfirstmarathon/site/SitePricing";
import { SiteProof } from "@/components/myfirstmarathon/site/SiteProof";
import { SitePromise } from "@/components/myfirstmarathon/site/SitePromise";
import { useMobile } from "@/components/myfirstmarathon/useMobile";
import "./myfirstmarathon/myfirstmarathon.css";

const TITLE = "My First Marathon - You'll finish.";
const DESCRIPTION = "A quiet, adaptive training plan for your first marathon.";

export default function MyFirstMarathonPage() {
  const mobile = useMobile();

  useEffect(() => {
    document.title = TITLE;

    let description = document.querySelector<HTMLMetaElement>(
      'meta[name="description"]',
    );
    if (!description) {
      description = document.createElement("meta");
      description.name = "description";
      document.head.appendChild(description);
    }
    description.content = DESCRIPTION;
  }, []);

  return (
    <main
      className="mfm-screen"
      data-mode="light"
      data-accent="burgundy"
      style={{
        width: "100%",
        minHeight: "100%",
        background: "var(--bg)",
        color: "var(--text)",
        fontFamily: "var(--ui)",
      }}
    >
      <SiteNav mobile={mobile} />
      <SiteHero mobile={mobile} />
      <SitePromise mobile={mobile} />
      <SitePlan mobile={mobile} />
      <SiteCoach mobile={mobile} />
      <SiteProof mobile={mobile} />
      <SiteKeepsakeQuote mobile={mobile} />
      <SitePricing mobile={mobile} />
      <SiteAbout mobile={mobile} />
      <SiteFinalCTA mobile={mobile} />
      <SiteFooter mobile={mobile} />
    </main>
  );
}
